export const formatDateShort = (dateStr?: string) => {
  if (!dateStr) return '';
  try {
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${mm}-${dd}`;
  } catch (e) {
    return dateStr;
  }
};

export const parseTimeToMinutes = (hhmm?: string): number | undefined => {
  if (!hhmm || typeof hhmm !== 'string') return undefined;
  const m = hhmm.match(/^(\d{1,2}):(\d{2})$/);
  if (!m) return undefined;
  const h = Number(m[1]);
  const min = Number(m[2]);
  if (isNaN(h) || isNaN(min)) return undefined;
  return h * 60 + min;
};

export const getNowMinutes = (): number => {
  const d = new Date();
  return d.getHours() * 60 + d.getMinutes();
};

const DEFAULT_MINUTES = 9 * 60;

const resolveTimelineTime = (item: any): string | undefined => {
  if (!item || typeof item !== 'object') return undefined;
  const direct = typeof item.time === 'string' ? item.time : undefined;
  if (direct && direct.trim()) return direct;
  const metaTime = item.meta?.start_time || item.meta?.startTime || item.meta?.time;
  if (typeof metaTime === 'string' && metaTime.trim()) return metaTime;
  const fallback = item.start_time || item.startTime;
  if (typeof fallback === 'string' && fallback.trim()) return fallback;
  return undefined;
};

const resolveCreatedAt = (item: any): number | undefined => {
  const raw = item?.created_at || item?.createdAt || item?.meta?.created_at || item?.meta?.createdAt;
  if (!raw || typeof raw !== 'string') return undefined;
  const ts = Date.parse(raw);
  return Number.isNaN(ts) ? undefined : ts;
};

export const compareTimelineItems = (
  a: any,
  b: any,
  parseTime: (value?: string) => number | undefined = parseTimeToMinutes,
): number => {
  const minutesA = parseTime(resolveTimelineTime(a)) ?? DEFAULT_MINUTES;
  const minutesB = parseTime(resolveTimelineTime(b)) ?? DEFAULT_MINUTES;
  if (minutesA !== minutesB) return minutesA - minutesB;

  const createdA = resolveCreatedAt(a);
  const createdB = resolveCreatedAt(b);
  if (createdA !== undefined && createdB !== undefined && createdA !== createdB) {
    return createdA - createdB;
  }

  const titleA = typeof a?.title === 'string' ? a.title : '';
  const titleB = typeof b?.title === 'string' ? b.title : '';
  if (titleA && titleB && titleA !== titleB) {
    return titleA.localeCompare(titleB);
  }

  return String(a?.id || '').localeCompare(String(b?.id || ''));
};
